declare global {
  interface String {
    toDate(): Date;
    toDateString(): string;
    toDateString(detailed: boolean): string;
    toTimeString(): string;
    toTimeTransferString(): string;
  }

  interface Date {
    toDateTimeString(): string;
  }
}

String.prototype.toDateString = function (this: string, detailed: boolean) {
  return DateTimeHelpers.toDateString(this as string, detailed);
} as any;

String.prototype.toDate = function (this: string) {
  return DateTimeHelpers.toDate(this as string);
} as any;

Date.prototype.toDateTimeString = function (this: Date) {
  return DateTimeHelpers.toDateTimeString(this as Date);
} as any;

String.prototype.toTimeString = function (this: string) {
  return DateTimeHelpers.toTimeString(this as string);
} as any;

String.prototype.toTimeTransferString = function (this: string) {
  return DateTimeHelpers.toTimeTransferString(this as string);
} as any;

export class DateTimeHelpers {
  private static leftPadNum(base: number, length: number = 2) {
    var baseString = base.toString();
    const padLen = length - baseString.length;
    let res = baseString;
    if (padLen > 0) {
      res = '0'.repeat(padLen) + baseString;
    }
    return res;
  }

  public static toUtcDate(transferString: string) {
    const utcDate: Date = new Date(transferString);
    const localDateMs: number =
      utcDate.getTime() + utcDate.getTimezoneOffset() * 60 * 1000;
    return new Date(localDateMs);
  }

  public static addDays(date: Date, amount: number) {
    date.setDate(date.getDate() + amount);
    return date;
  }

  public static toDateInputString(transferString: string) {
    const date = new Date(transferString);
    var month = date.getMonth() + 1;
    var res =
      this.leftPadNum(date.getFullYear(), 4) +
      '-' +
      this.leftPadNum(month) +
      '-' +
      this.leftPadNum(date.getDate());
    if (date.getFullYear() === 1970) {
      return '';
    }
    return res;
  }
  public static toMonthInputString(transferString: string) {
    const date = new Date(transferString);
    var month = date.getMonth() + 1;
    var res =
      this.leftPadNum(date.getFullYear(), 4) + '-' + this.leftPadNum(month);
    if (date.getFullYear() === 1970) {
      return '';
    }
    return res;
  }

  public static toDateInputFromUtcString(utcDate: string | null | undefined) {
    if (utcDate == null) {
      return '';
    }
    const year = Number(utcDate.substring(0, 4));
    if (year <= 1960) {
      return '';
    }
    console.log(utcDate.substring(0, 10));
    return utcDate.substring(0, 10);
  }

  public static toDateTimeOffsetString(localDate: Date) {
    return localDate.toISOString();
  }

  public static toDate(transferString: string) {
    if (!transferString || transferString.length < 8) return new Date(0);

    if (transferString.length < 14) {
      var year = Number.parseInt(transferString.substr(0, 4));
      var month = Number.parseInt(transferString.substr(4, 2));
      var day = Number.parseInt(transferString.substr(6, 2));

      if (!year || !month || !day) return new Date(0);

      return new Date(year, month, day);
    }
    return new Date(transferString);
  }

  public static toDateString(transferString: string, detailed: boolean) {
    if (!transferString || transferString.length < 8) return 'Invalid time';

    if (transferString.length < 14) {
      var year = Number.parseInt(transferString.substr(0, 4));
      var month = Number.parseInt(transferString.substr(4, 2));
      var day = Number.parseInt(transferString.substr(6, 2));

      if (!year || !month || !day) return 'Invalid time';

      return (
        DateTimeHelpers.leftPadNum(day) +
        '.' +
        DateTimeHelpers.leftPadNum(month) +
        '.' +
        year
      );
    }
    var localDate = new Date(transferString);

    return (
      DateTimeHelpers.leftPadNum(localDate.getDate()) +
      '.' +
      DateTimeHelpers.leftPadNum(localDate.getMonth() + 1) +
      '.' +
      localDate.getFullYear() +
      ' ' +
      DateTimeHelpers.leftPadNum(localDate.getHours()) +
      ':' +
      DateTimeHelpers.leftPadNum(localDate.getMinutes()) +
      (detailed ? ':' + DateTimeHelpers.leftPadNum(localDate.getSeconds()) : '')
    );
  }

  public static toDateTimeString(date: Date) {
    return (
      DateTimeHelpers.leftPadNum(date.getDate()) +
      '.' +
      DateTimeHelpers.leftPadNum(date.getMonth() + 1) +
      '.' +
      date.getFullYear() +
      ' ' +
      DateTimeHelpers.leftPadNum(date.getHours()) +
      ':' +
      DateTimeHelpers.leftPadNum(date.getMinutes()) +
      ':' +
      DateTimeHelpers.leftPadNum(date.getSeconds())
    );
  }

  public static toTimeString(value: string) {
    if (value.length != 4) return value;
    return value.substr(0, 2) + ':' + value.substr(2);
  }

  public static toTimeTransferString(value: string) {
    value = value.replace(':', '');
    return value.length == 3 ? '0' + value : value;
  }
}

export {};
